import React from "react";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { router } from "./routes";
import PWAPrompt from "./components/PWAPrompt";
import OptInModal from "./components/OptInModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const handleOptInSuccess = (data) => {
    console.log("Opt-in successful:", data);
    // You can add a toast notification here if needed
  };

  const handleOptInError = (error) => {
    console.error("Opt-in failed:", error);
    // You can add error handling here if needed
  };

  return (
    <>
      <AuthProvider>
        <RouterProvider router={router} />
        <PWAPrompt />
        <OptInModal onSuccess={handleOptInSuccess} onError={handleOptInError} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </AuthProvider>
    </>
  );
}

export default App;
